import React from "react";
import RemitterAccountDetails from "../../../../containers/Accounts/RemitterAccount/RemitterAccountDetails";
import ICONS from "../../../../assets/Icons";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import { useNavigate } from "react-router-dom";

const RemitAccountDetailsPopup = ({
  rem_account_id,
  popup,
  headerTitle,
  headersubtext,
  closeRemAccountDetailModal,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div onClick={(e) => e.stopPropagation()}>
        <LargePopupRedirect
          headerTitle={headerTitle}
          headerFontWeight="semibold"
          headerFontColor="text-primary"
          headertextSize="font-md"
          headersubtext={headersubtext}
          isfullViewrequired={true}
          fullviewbtnText="Open in full view"
          fullviewbtnType="button"
          fullviewhandleFunction={() => {
            closeRemAccountDetailModal();
            navigate(
              `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${rem_account_id}`,
            );
          }}
          fullviewisDisabled={false}
          fullviewenabledTextColor="var(--text-primary)"
          fullviewenabledBgColor="var(--primary-nav)"
          fullviewhoverOption="white"
          fullviewicon={ICONS?.REDIRECT}
          fullviewdisabledBgColor="var(--text-disabled)"
          closeiconbtnType="button"
          closeiconhandleFunction={closeRemAccountDetailModal}
          closeiconisDisabled={false}
          closeiconenabledBgColor="var(--primary-nav)"
          closeicondisabledBgColor="var(--text-disabled)"
          closeiconhoverOption="white"
          closeicon={ICONS?.CLOSE}
          isbottomSectionneed={false}
          bottomHeaderTextNeed={false}
        >
          <RemitterAccountDetails
            rem_account_id={rem_account_id}
            closeBeneAccountDetailModal={closeRemAccountDetailModal}
            popup={popup}
          />
        </LargePopupRedirect>
      </div>
    </>
  );
};

export default RemitAccountDetailsPopup;
